export default __webpack_public_path__ + "static/media/comercio_5.9911bc1f.png";